import React from 'react';

const isBottom = (el: HTMLDivElement): boolean => {
  return Math.ceil(el.offsetHeight + el.scrollTop) >= el.scrollHeight;
};

const isWindowScrollToBottom = (el: HTMLDivElement): boolean => {
  return el.getBoundingClientRect().bottom <= window.innerHeight;
};
export const useScrollToBottom = (
  loadMore: () => void,
  canLoadMore?: boolean,
  eventFromWindow?: boolean
): ((node: HTMLDivElement) => void) => {
  const container = React.useRef<HTMLDivElement | null>();
  const [renderCount, setRenderCount] = React.useState(0);
  const forceRender = (): void => setRenderCount((val) => val + 1);
  const windowIfNoSsr = typeof window !== 'undefined' ? window : undefined;
  const trackNode = eventFromWindow ? windowIfNoSsr : container.current;
  React.useEffect(() => {
    const scrollToBottom = (): void => {
      const isScrollToBottom = eventFromWindow
        ? container.current && isWindowScrollToBottom(container.current)
        : container.current && isBottom(container.current);
      if (isScrollToBottom && canLoadMore) {
        loadMore();
      }
    };
    trackNode?.addEventListener('scroll', scrollToBottom);
    return (): void => {
      trackNode?.removeEventListener('scroll', scrollToBottom);
    };
  }, [renderCount, canLoadMore, eventFromWindow, loadMore, trackNode]);
  const containerRef = React.useCallback((node: HTMLDivElement | null) => {
    container.current = node;
    forceRender();
  }, []);
  return containerRef;
};
